import React, { useEffect, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { ActionButtons, Subtitle, Title } from '../Utils/CustomClasses'
import Cookies from 'universal-cookie'
import styled from 'styled-components'

const cookies = new Cookies()

const ModalDiv = styled.div`
  background-color: white;
  border: 1px solid #c1c1c1;
  box-shadow: 0 5px 9px -2px #a8a8a8;
  border-radius: 12px;
  padding: 24px 22px 30px 40px;
  width: 70%;

  @media (max-width: 900px) {
    padding: 24px 2px 30px 2px;
    width: 90%;
  }
`

const TopCont = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 900px) {
    padding: 0 25px;
  }
`

const MiddleCont = styled(TopCont)`
  padding: 0 115px 20px 0;

  @media (max-width: 900px) {
    padding: 0 25px 20px;
  }
`

const TextDiv = styled.div`
  flex-basis: 60%;
  margin-right: 20px;

  & ul {
    list-style: none;
    padding-bottom: 23px;
  }

  @media (max-width: 900px) {
    margin-right: 0;
  }
`

const ImageDiv = styled.div`
  flex-basis: 40%;
  text-align: right;

  & img {
    width: 70px;
  }

  @media (max-width: 900px) {
    /*text-align: left;*/

    & img {
      width: 60px;
    }
  }
`

const PopUpTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif !important;
  font-size: 26px;
  color: #000;
  margin: 22px 0 32px 0;

  @media (max-width: 600px) {
    font-size: 24px;
  }

  @media (max-width: 440px) {
    margin: 0 0 30px 0;
  }
`

const PopUpSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 190%;
  color: #000;
  margin-bottom: 46px;

  @media (max-width: 600px) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 0 28px 0 0;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    margin: 0 18px 0 18px;
  }
`

const FrL = styled.div`
  flex-basis: 50%;
  text-align: left;

  @media screen and (max-width: 900px) {
    text-align: center;
    width: 100%;
  }
`

const FrR = styled.div`
  flex-basis: 50%;
  text-align: right;

  @media screen and (max-width: 900px) {
    text-align: center;
    width: 100%;
  }
`

const ActionButtonMyFreebird = styled(ActionButtons)`
  color: #000;
  padding: 10px 45px;
  background-color: #ff9900;
  border: 1px solid #ff9900;
  border-radius: 12px;
  font-size: 18px;
  margin: 0 5px 10px 5px;
  text-decoration: none;
  width: 100%;

  &:hover {
    color: #fff;
    font-weight: normal;
    background-color: #787878;
    border: 1px solid #787878;
  }

  &:focus {
    color: #000 !important;
    font-weight: normal;
    background-color: #ff9900 !important;
    border: 1px solid #ff9900 !important;
    box-shadow: none;
  }

  @media (max-width: 900px) {
    margin: 0 0 10px 0;
  }
`

const CloseButtonMyFreebird = styled(ActionButtonMyFreebird)`
  color: #fff;
  background-color: #000;
  border: 1px solid #000;
  width: 190px;

  &:hover {
    color: #fff;
    background-color: #787878;
    border: 1px solid #787878;
  }

  &:focus {
    background-color: #000 !important;
    border: 1px solid #000 !important;
  }

  @media (max-width: 900px) {
    width: -webkit-fill-available;
  }
`

const MyFreebirdPopup = ({
  pageText,
  user,
  forbiddenLinkClicked,
  newMemberMessage,
  onUpdate,
}) => {
  const [showPopup, setShowPopup] = useState(false)
  const [intersectingDelay, setIntersectingDelay] = useState(300)
  const [messageTitle, setMessageTitle] = useState('')
  const [messageText, setMessageText] = useState('')
  const [buttonText, setButtonText] = useState('')
  const [buttonAction, setButtonAction] = useState('')

  useEffect(() => {
    if (user.subscriptionType === 'freemium') {
      if (forbiddenLinkClicked[0] === true) {
        setShowPopup(true)
        if (forbiddenLinkClicked[1].includes('lp=events')) {
          setMessageTitle('Member events:')
          setMessageText(
            'To view and attend Member events you need a paid membership plan. To upgrade your membership plan please click on the button below.'
          )
          setButtonText('Upgrade membership')
          setButtonAction('upgrade')
        }
      } else if (newMemberMessage !== '') {
        /*
        setShowPopup(true)
        switch (newMemberMessage) {
          case 'nf':
            if (cookies.get('nfv') !== 'y') {
              setMessageTitle('Welcome!')
              setMessageText(
                'Freebird members are waiting to meet you. Please click on the button below to visit the member introductions area and say a quick hello.'
              )
              setButtonText('Introduce yourself')
              setButtonAction('intro')
            } else {
              setShowPopup(false)
            }
            break
          default:
            setShowPopup(false)
        }
            */
      } else {
        setShowPopup(false)
      }
    } else {
      if (newMemberMessage !== '') {
        setShowPopup(true)
        switch (newMemberMessage) {
          case 'mu':
            if (cookies.get('muv') !== 'y') {
              setMessageTitle('Membership activated:')
              user.proofIdentityStatus === 'pending'
                ? setMessageText(
                    'Your paid membership plan has been successfully activated and you can now enter members-only community spaces. However, in order to make a homestay request, list your home for rental, or send another member a personal message you will need to verify your account by uploading a photo ID.'
                  )
                : setMessageText(
                    'Your paid membership plan has been successfully activated and you can now enter members-only community spaces, direct message other members, make homestay requests and list your property for homestays.'
                  )
              setButtonText('Verify account')
              setButtonAction('verify')
            } else {
              setShowPopup(false)
            }
            break
          case 'emf':
            setMessageTitle('Email not verified:')
            setMessageText(
              'Your email address is not yet verified. Please click on the link in the email we sent you to verify it. If this does not work please try re-sending the verification email.'
            )
            setButtonText('Resend email')
            setButtonAction('resendemail')
            break
          default:
            setShowPopup(false)
        }
      } else {
        setShowPopup(false)
      }
    }
  }, [forbiddenLinkClicked, newMemberMessage, pageText, user])

  const fadeStyles = useSpring({
    delay: showPopup ? intersectingDelay : 0,
    config: { duration: 200, config: 'gentle' },
    from: { opacity: 0, top: '80px' },
    to: {
      opacity: showPopup ? 1 : 0,
      top: showPopup ? '0' : '80px',
    },
  })

  const closePopup = (e) => {
    e.preventDefault()
    setShowPopup(false)
    inhibitInfoPopUpAfterViewing()
    onUpdate()
  }

  const actionButtoneClicked = (e, buttonAction) => {
    e.preventDefault()
    setShowPopup(false)
    inhibitInfoPopUpAfterViewing()
    onUpdate()
    if (buttonAction === 'upgrade') {
      window.open('/onboarding?p=mp', '_self')
    } else if (buttonAction === 'intro') {
      window.open(
        '/dashboard/community2?lp=freebird-club-member-introductions',
        '_self'
      )
    } else if (buttonAction === 'resendemail') {
      window.open('/onboarding?p=em', '_self')
    } else {
      window.open('/myfreebird?s=vf', '_self')
    }
  }

  const inhibitInfoPopUpAfterViewing = () => {
    console.log('inhibitInfoPopUpAfterViewing..')
    newMemberMessage === 'nf' &&
      cookies.set('nfv', 'y', { path: '/', maxAge: 86400 })
    newMemberMessage === 'mu' &&
      cookies.set('muv', 'y', { path: '/', maxAge: 86400 })
  }

  return (
    <animated.div
      style={{
        display: 'flex',
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: 9999999,
        justifyContent: 'center',
        pointerEvents: 'none',
        alignItems: 'center',
        overflow: 'hidden',
        ...fadeStyles,
      }}
      className={showPopup && 'is-clickable'}
    >
      <ModalDiv>
        <TopCont>
          <TextDiv>
            <PopUpTitle>{messageTitle}</PopUpTitle>
          </TextDiv>
          <ImageDiv>
            <img src="/images/profile/lightbulb-lt.svg" />
          </ImageDiv>
        </TopCont>
        <MiddleCont>
          <PopUpSubtitle>{messageText}</PopUpSubtitle>
        </MiddleCont>
        <FlexRow>
          <FrL>
            <ActionButtonMyFreebird
              className="btn btn-primary"
              to=""
              onClick={(e) => actionButtoneClicked(e, buttonAction)}
            >
              {buttonText}
            </ActionButtonMyFreebird>
          </FrL>
          <FrR>
            {' '}
            <CloseButtonMyFreebird
              className="btn btn-primary"
              to=""
              onClick={(e) => closePopup(e)}
            >
              Close
            </CloseButtonMyFreebird>
          </FrR>
        </FlexRow>
      </ModalDiv>
    </animated.div>
  )
}

export default withRouter(withAuth(MyFreebirdPopup))
